import React, { useState, useEffect } from "react";
import Image from "../banner.jpg";
import axios from "axios";
import { Oval } from "react-loader-spinner";
import Pagination from "./Pagination";

function Movies() {
  const [movies, setMovies] = useState([]);
  const [page, setPage] = useState(1);
  const [hover, setHover] = useState("");
  const [favourites, setFavourites] = useState([]);

  function goAhead() {
    setPage(page + 1);
  }
  function goBack() {
    if (page > 1) {
      setPage(page - 1);
    }
  }
  useEffect(
    function () {
      // everytime when page reloads
      let oldFav = localStorage.getItem("imdb");
      oldFav = JSON.parse(oldFav) || [];
      console.log(oldFav);
      // setFavourites(oldFav);
      // data manga
      axios
        .get(
          `https://api.themoviedb.org/3/trending/movie/week?api_key=21fec78a0a45ce6c7e1bead5fd278462&page=${page}`
        )
        .then((res) => {
          console.table(res.data.results);
          setMovies(res.data.results);
        });
    },
    [page]
  );

  /*emoji show and hide on hover*/
  const showEmoji = (id) => {
    setHover(id);
  };
  const hideEmoji = () => {
    setHover("");
  };
  /*adding / removeing emojis to fav*/

  let handleFavourites = (movie) => {
    let oldData = JSON.parse(localStorage.getItem("imdb") || "[]");
    if (favourites.includes(movie.id)) {
      oldData = oldData.filter((m) => m.id !== movie.id);
    } else {
      oldData.push(movie);
    }
    localStorage.setItem("imdb", JSON.stringify(oldData));
    console.log(oldData);
    handlefavouriteState();
  };

  let handlefavouriteState = () => {
    let oldData = JSON.parse(localStorage.getItem("imdb") || "[]");
    let temp = oldData.map((movie) => movie.id);
    setFavourites([...temp]);
  };

  return (
    <div className="mt-8">
      <div
        className="mb-8
        font-bold text-2xl text-center
        "
      >
        Trending Movies
      </div>
      <div
        className="flex 
        flex-wrap
        justify-center
        "
      >
        {movies.length === 0 ? (
          <Oval
            height="80"
            width="80"
            radius="9"
            color="gray"
            secondaryColor="gray"
            ariaLabel="loading"
          />
        ) : (
          movies.map((movie) => {
            return (
              <div
                onMouseOver={() => {
                  showEmoji(movie.id);
                }}
                onMouseLeave={() => {
                  hideEmoji(movie.id);
                }}
                key={movie.id}
                className="
            bg-center bg-cover    
            w-[160px]
            h-[30vh]
            md: h-[40vh]
            md:w-[180px]
            m-4
            rounded-xl
            hover:scale-110
            duration-300
             flex items-end 
             relative
            "
                style={{
                  backgroundImage: `url(
                                https://image.tmdb.org/t/p/original/t/p/w500/${movie.poster_path})`,
                }}
              >
                <div
                  className="p-2
bg-gray-900
                            absolute top-2 right-2
                            rounded-xl
                           "
                  style={{
                    display: hover === movie.id ? "block" : "none",
                  }}
                >
                  {favourites.includes(movie.id) === false ? (
                    <div
                      className="
                            text-2xl
                            "
                      onClick={() => {
                        handleFavourites(movie);
                      }}
                    >
                      😍
                    </div>
                  ) : (
                    <div
                      className="
                            text-2xl
                            "
                      onClick={() => {
                        handleFavourites(movie);
                      }}
                    >
                      ❌
                    </div>
                  )}
                </div>
                <div
                  className="
                font-bold text-white
            bg-gray-900 bg-opacity-60
            p-2
            text-center
            w-full
            rounded-b-xl
            "
                >
                  {" "}
                  {movie.title || movie.name}
                </div>
              </div>
            );
          })
        )}
      </div>
      <Pagination pageProp={page} goBack={goBack} goAhead={goAhead} />
    </div>
  );
}

export default Movies;
